// 3rd party imports
import * as React from 'react';

// Bernie
import { LocalizedText } from '@shared-ui/localization-context';
import { UitkDialogContent } from 'uitk-react-dialog';
import { UitkHeading } from 'uitk-react-text';
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkList } from 'uitk-react-list';

export interface PzFormInfoListProps {
  titleName: string;
  rules: string[];
}

export const PzFormInfoList: React.FunctionComponent<PzFormInfoListProps> = ({ titleName, rules }) => {
  return (
    <UitkDialogContent>
      <UitkHeading tag="h3" size={5}>
        <LocalizedText message={titleName} />
      </UitkHeading>
      <UitkSpacing margin={{ blockstart: 'six' }}>
        <div>
          <UitkList data={rules} />
        </div>
      </UitkSpacing>
    </UitkDialogContent>
  );
};
